import axios from 'axios'
import qs from 'qs'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    // incidencias
    issues: {
      tableData: [],
      totalIssues: 0
    },
    queryIssues: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      creationDateTimeFrom: null,
      creationDateTimeTo: null
    },
    listSelectedFiltersIssues: [],
     // Datos Select Filtros Incidencias
     optionsFilterStatusIssue: [],
     optionsFilterBuyerIssue: [],
     optionsFilterSellerIssue: [],
     optionsFilterSummaryIssue: [],
     optionsFilterDateCreationIssue: [],
     optionsFilterPriorityIssue: [],
     optionsFilterTypeIssue: [],
  }
  return session
}

function initLocal () {
  const local = {

    // Columnas Tabla incidencias
    isShowServicioIssue: true,
    isShowCompradorIssue: true,
    isShowVendedorIssue: true,
    isShowAsuntoIssue: true,
    isShowFechaRegistroIssue: true,
    isShowEstadoIssue: true,
    isShowTipoIssue: true,
    isShowPrioridadIssue: true
  }
  return local
}

function setByUserLocalIssue () {
  const local = {
    // Columnas Tabla incidencias
    isShowCompradorIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowCompradorIssue,
    isShowFechaRegistroIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowFechaRegistroIssue,
    isShowEstadoIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowEstadoIssue,
    isShowVendedorIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowVendedorIssue,
    isShowServicioIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowServicioIssue,
    isShowAsuntoIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowAsuntoIssue,
    isShowPrioridadIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowPrioridadIssue,
    isShowTipoIssue: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).issues.isShowTipoIssue
  }
  return local
}

// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla incidencias
    isShowServicioIssue: true,
    isShowCompradorIssue: true,
    isShowVendedorIssue: true,
    isShowAsuntoIssue: true,
    isShowFechaRegistroIssue: true,
    isShowEstadoIssue: true,
    isShowTipoIssue: true,
    isShowPrioridadIssue: true
  },
  session: initSession()
}

const getters = {
  // incidencias
  issues: state => {
    return state.session.issues
  },
  queryIssues: state => {
    return state.session.queryIssues
  },
  listSelectedFiltersIssues: state => {
    return state.session.listSelectedFiltersIssues
  },
  optionsFilterStatusIssue: state => {
    return state.session.optionsFilterStatusIssue
  },
  optionsFilterBuyerIssue: state => {
    return state.session.optionsFilterBuyerIssue
  },
  optionsFilterSellerIssue: state => {
    return state.session.optionsFilterSellerIssue
  },
  optionsFilterSummaryIssue: state => {
    return state.session.optionsFilterSummaryIssue
  },
  optionsFilterDateCreationIssue: state => {
    return state.session.optionsFilterDateCreationIssue
  },
  optionsFilterPriorityIssue: state => {
    return state.session.optionsFilterPriorityIssue
  },
  optionsFilterTypeIssue: state => {
    return state.session.optionsFilterTypeIssue
  },
  isShowCompradorIssue: state => {
    return state.local.isShowCompradorIssue
  },
  isShowFechaRegistroIssue: state => {
    return state.local.isShowFechaRegistroIssue
  },
  isShowEstadoIssue: state => {
    return state.local.isShowEstadoIssue
  },
  isShowVendedorIssue: state => {
    return state.local.isShowVendedorIssue
  },
  isShowServicioIssue: state => {
    return state.local.isShowServicioIssue
  },
  isShowAsuntoIssue: state => {
    return state.local.isShowAsuntoIssue
  },
  isShowPrioridadIssue: state => {
    return state.local.isShowPrioridadIssue
  },
  isShowTipoIssue: state => {
    return state.local.isShowTipoIssue
  },

  issuesList: state => {
    return state.session.issuesList
  }
}

const actions = {

  // Crear key Usuario
  setUserNameIssue ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalIssue()
    }
  },

  async isNewVersionIssuesLocalState ({ state }, localStorage) {
    const isnew = fn.isNewVersion(state, localStorage.issues)
    return isnew
  },

  async deleteIssue ({
    commit, rootState
  }, issueId) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/issue/' + issueId +'/deleteIssue',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          issueId: issueId
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Añade un estado a la incidencia
   * @param {*} param0
   * @param {*} data
   */
  async addIssueStatus ({
    commit,
    rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/issue/' + data.idIssue + '/addStatus',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR addStatus --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para traer las incidencias.
     * Se utiliza también para ordenar la tabla, la paginación,
     * el tamaño de la tabla y los filtros.
     */
  async getIssues ({
    commit,
    rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
            rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/issue',
        params: data.query,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      console.log('estamos recuperando totalElements ', response.data.totalElements)

      commit('ISSUES_STATE', { tableData: response.data.content, totalIssues: response.data.totalElements })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR getIssues --- ', error.response)
      throw error.response
    }
  },
  async getIssueById ({
    commit, rootState
  }, issueId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/issue/' + issueId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getIssueStatus ({
    commit, rootState
  }, issueId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/issue/' + issueId + '/statusList',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro tipo de
     * incidencia.
     */
   async getOptionsFilterTypeIssue ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/issue/type',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterTypeIssue = response.data
      commit('OPTIONS_FILTER_TYPE_ISSUE', optionsFilterTypeIssue)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterTypeIssue
    } catch (error) {
      console.log('ERROR optionsFilterTypeIssue --- ', error.response)
      throw error.response
    }
  },
   /**
     * Servicio para llenar Select Filtro estados de
     * incidencia.
     */
    async getOptionsFilterStatusIssue ({
      commit, rootState
    }) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/issue/status',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })

        const optionsFilterStatusIssue = response.data
        commit('OPTIONS_FILTER_STATUS_ISSUE', optionsFilterStatusIssue)

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return optionsFilterStatusIssue
      } catch (error) {
        console.log('ERROR optionsFilterStatusIssue --- ', error.response)
        throw error.response
      }
    },

   /**
     * Servicio para llenar Select Filtro estados de
     * incidencia para nuevo estado
     */
    async getStatusIssue ({
      commit, rootState
    }, data) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/issue/status',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: data
        })
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR getStatusIssue --- ', error.response)
        throw error.response
      }
    },


  // Acciones para tabla de incidencias
  queryIssuesState: ({
    commit
  }, payload) => {
    commit('QUERY_ISSUES_STATE', payload)
  },
  listSelectedFiltersIssuesState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_ISSUES', payload)
  },
  optionsFilterStatusIssueState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_STATUS_ISSUE', payload)
  },
  optionsFilterBuyerIssueState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_BUYER_ISSUE', payload)
  },
  optionsFilterSellerIssueState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_SELLER_ISSUE', payload)
  },
  optionsFilterSummaryIssueState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_SUMMARY_ISSUE', payload)
  },
  optionsFilterDateCreationIssueState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_ISSUE', payload)
  },
  optionsFilterPriorityIssueState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_PRIORITY_ISSUE', payload)
  },
  optionsFilterTypeIssueState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_TYPE_ISSUE', payload)
  },
  isShowCompradorIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_COMPRADOR_ISSUE', payload)
  },
  isShowFechaRegistroIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_REGISTRO_ISSUE', payload)
  },
  isShowEstadoIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ESTADO_ISSUE', payload)
  },
  isShowVendedorIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_VENDEDOR_ISSUE', payload)
  },
  isShowAsuntoIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ASUNTO_ISSUE', payload)
  },
  isShowPrioridadIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PRIORIDAD_ISSUE', payload)
  },
  isShowTipoIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_TIPO_ISSUE', payload)
  },
  isShowServicioIssueState: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERVICIO_ISSUE', payload)
  },

  // Acciones comunes
  selectIssue ({
    commit,
    state
  }, issue) {
    return new Promise((resolve, reject) => {
      commit('SELECTED_ISSUE', issue)
      resolve()
    })
  },


  /**
     * Servicio para modificar los datos de una Incidencia
     * @param {*} params
     */
  async newIssue ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/issue',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: params
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  issueTypeState: ({
    commit
  }, payload) => {
    commit('ISSUE_TYPE', payload)
  }
}

// mutations
const mutations = {
  resetSessionIssues (state) {
    state.session = initSession()
    state.local = initLocal()
  },

  // user = JSON.parse(sessionStorage.getItem('activeUser')),

  // Datos incidencias
  issuesDatesSuperAdmin (state) {
    state.session.queryIssues.creationDateTimeFrom = fn.initDateFrom(1)
  },
  'ISSUES_STATE' (state, payload) {
    state.session.issues = payload
  },
  'QUERY_ISSUES_STATE' (state, payload) {
    state.session.queryIssues = payload
  },
  'LIST_SELECTED_FILTERS_ISSUES' (state, payload) {
    state.session.listSelectedFiltersIssues = payload
  },

  'OPTIONS_FILTER_STATUS_ISSUE'(state, payload) {
    state.session.optionsFilterStatusIssue = payload
  },
  'OPTIONS_FILTER_BUYER_ISSUE'(state, payload) {
    state.session.optionsFilterBuyerIssue = payload
  },
  'OPTIONS_FILTER_SELLER_ISSUE'(state, payload) {
    state.session.optionsFilterSellerIssue = payload
  },
  'OPTIONS_FILTER_SUMMARY_ISSUE'(state, payload) {
    state.session.optionsFilterSummaryIssue = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_ISSUE'(state, payload) {
    state.session.optionsFilterDateCreationIssue = payload
  },
  'OPTIONS_FILTER_PRIORITY_ISSUE'(state, payload) {
    state.session.optionsFilterPriorityIssue = payload
  },
  'OPTIONS_FILTER_TYPE_ISSUE'(state, payload) {
    state.session.optionsFilterTypeIssue = payload
  },
  // Columnas
  'IS_SHOW_COMPRADOR_ISSUE' (state, payload) {
    state.local.isShowCompradorIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowCompradorIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_REGISTRO_ISSUE' (state, payload) {
    state.local.isShowFechaRegistroIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowFechaRegistroIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ESTADO_ISSUE' (state, payload) {
    state.local.isShowEstadoIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowEstadoIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_VENDEDOR_ISSUE' (state, payload) {
    state.local.isShowVendedorIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowVendedorIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICIO_ISSUE' (state, payload) {
    state.local.isShowServicioIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowServicioIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ASUNTO_ISSUE' (state, payload) {
    state.local.isShowAsuntoIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowAsuntoIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PRIORIDAD_ISSUE' (state, payload) {
    state.local.isShowPrioridadIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowPrioridadIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TIPO_ISSUE' (state, payload) {
    state.local.isShowTipoIssue = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.issues.isShowTipoIssue = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Mutaciones comunes
  'SELECTED_ISSUE' (state, issue) {
    state.local.issue = issue
  },
  'ISSUE_TYPE' (state, payload) {
    state.session.issueType = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
